import {axios, HOST, config} from './settiing';

export default {
    getCouponList(id) {
        return axios.get(`${HOST}/resource/coupon/list/${id}`, config);
    },
    getUsedCoupons(id) {
        return axios.get(`${HOST}/resource/coupon/resrv/${id}`, config);
    }
}
